import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { DateFormatConstants } from '@uzurv/rideWss/app/constants';
import { AbstractModel } from './abstract-model';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import moment from 'moment-timezone';

@inheritSerialization(AbstractModel)
export class RiderEligibilityProofRequest extends AbstractModel {
  @autoserialize
  firstName: string;

  @autoserialize
  lastName: string;

  @autoserializeAs(Date)
  dateOfBirth: Date;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  partnerIdentifier: string;

  @autoserialize
  emailAddress: string;

  static OnSerialized(instance: RiderEligibilityProofRequest, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.firstName)) {
      json.firstName = instance.firstName.trim();
    }

    if (!isNullOrUndefined(instance.lastName)) {
      json.lastName = instance.lastName.trim();
    }

    if (!isNullOrUndefined(instance.dateOfBirth)) {
      json.dateOfBirth = moment.utc(instance.dateOfBirth).format(DateFormatConstants.ISO_LOCAL_DATE);
    }

    if (!isNullOrUndefined(instance.phoneNumber)) {
      json.phoneNumber = instance.phoneNumber.trim();
    }

    if (!isNullOrUndefined(instance.partnerIdentifier)) {
      json.partnerIdentifier = instance.partnerIdentifier.trim();
    }

    if (!isNullOrUndefined(instance.emailAddress)) {
      json.emailAddress = instance.emailAddress.trim();
    }
  }

  static OnDeserialized(instance: RiderEligibilityProofRequest, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['dateOfBirth'])) {
      instance.dateOfBirth = moment(json['dateOfBirth']).toDate();
    }
  }
}
